<template>
<div>
     <v-progress-linear indeterminate  color="primary" v-if="loaders.detail_loader"></v-progress-linear>
    <v-container fluid grid-list-md class="dashboard">
        <v-layout row wrap>
            <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12 sm12 md5>
                <v-card outlined class="pa-2" height="100%">
                    <div>  
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color pb-0">Office Details</p>
                            </v-flex>
                            <v-flex>
                                <v-btn small color="error" class="ml-3 float_right" @click="delete_office_dialog_box=true">Delete</v-btn>
                                <v-btn small color="primary" class="ml-3 float_right" :to="`/offices/edit/${office_details.id}`">Edit</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-layout row wrap>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Name</v-list-item-subtitle>
                                            <v-list-item-title v-if="office_details.name!=null" class="pt-1">{{office_details.name |capitalize}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Unit No</v-list-item-subtitle>
                                            <v-list-item-title v-if="office_details.unit_no!=null" three-line wrap="true" class="pt-1">{{office_details.unit_no}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                     <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Email ID</v-list-item-subtitle>
                                            <v-list-item-title  v-if="office_details.email!=null"  three-line wrap="true" class="pt-1">{{office_details.email}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Address</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{office_details.address| capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Wing</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{office_details.wing.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Created At</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{formatDate(office_details.created_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md7>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color">Admins</p>
                            </v-flex>
                            <v-flex v-show="role!='Office Admin'">
                                <v-btn small color="primary" class="ml-3 float_right" :to="{ name: 'addUser', params: { office_id: this.office_details.id , office_name: this.office_details.name  } }">Add Admin</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-data-table :headers="user_headers" 
                                :items="office_related_users"  class="elevation-1" 
                                :loading="is_loading" 
                                :options.sync="options" 
                                :server-items-length="total_items"
                                :footer-props="{'items-per-page-options': [5,10,15,20,40]}"
                                 :items-per-page="5">
                                    <template v-slot:body="{ items }"  v-if="!is_loading && count!=0">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.name">
                                                <td>
                                                    <router-link :to="{ name:'showUserDetails',params: { id:item.id } }">{{ item.username }}</router-link>
                                                </td>
                                                <td>
                                                    <v-btn text icon color="primary" :to="`/users/edit/${item.id}`">
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                    <v-btn text icon color="red" @click="deleteUser(item)">
                                                        <v-icon>delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <template v-slot:loading> Loading... Please wait </template>
                                    <template v-slot:no-results> No data available </template>
                                </v-data-table>

                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

    <!-- Delete Office model -->
    <v-dialog v-model="delete_office_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
        <v-card>
            <v-form>
                <v-card-text class="pl-5 mt-3">
                  <h3>Are you sure you want to delete this Office ?</h3>
                </v-card-text>
                <v-card-actions class="pr-5 mb-3">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="deleteOffice">Delete</v-btn>
                    <v-btn color="black" text small @click="delete_office_dialog_box=false">Cancel</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Add user model -->
    <v-dialog v-model="add_user_dialog_box" scrollable :overlay="false" max-width="400px" transition="dialog-transition">
        <v-card>
            <v-form>
                <v-card-title>
                    <p class="text-color pb-0">Add Admin</p>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                     :items="users"
                      name="User Name"
                       v-model="search_user"
                        :search-input.sync="user_search" 
                        label="Select User" 
                        item-text="name" 
                        autocomplete="off"
                        item-value="id" 
                        clearable :messages="search_message">
                    </v-autocomplete>
                    <v-btn color="primary" small :to="{ name: 'addUser', params: { office_id: this.office_details.id  } }" class="mt-5">Create User</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="addUser">Add</v-btn>
                    <v-btn color="black" text small @click="add_user_dialog_box=false">Cancel</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <!-- Delete user model -->
    <v-dialog v-model="delete_user_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
        <v-card>
            <v-form>
               <v-card-text class="pl-5 mt-3">
                  <h3>Are you sure you want to delete this User ?</h3>
                </v-card-text>
                <v-card-actions class="pr-5 mb-3">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="confirmDeleteUser">Delete</v-btn>
                    <v-btn color="black" text small @click="delete_user_dialog_box=false">Cancel</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    watch: {
        "user_search": {
            handler(val) {
                if (val) {
                    if (val.length >= 3) {
                        this.search_message = "";
                        this.getUserList();
                    }
                } else {
                    this.search_message = "Enter atleast 3 characters";
                }

            }
        },
    },
    methods: {
        getOfficeDetails: function () {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices/` + this.$route.params.id).then(response => {
                  
                   if (response.data.status == 1) {
                        this.office_details = response.data.office_details;
                        this.office_related_users = response.data.office_details.users;
                        this.count = this.office_related_users.length;
                       

                        this.is_loading = false;
                    }if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = "Error Ocurred - Unable to get Office details"
                        this.is_loading = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        getUserList: function () {
            this.is_loading=true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/users/list`, {
                params: {
                    query_string: this.user_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.users = response.data.user_list;
                    this.total_items = response.data.user_list.total;
                    this.is_loading=false;

                }if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = "Error Ocurred - Unable to get User details";
                    }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });

        },
        deleteOffice() {
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/offices/` + this.office_details.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.delete_office_dialog_box = false;
                        this.$router.push({
                            name: 'offices',
                            params: {
                            success_message:'Office Deleted Successfully'
                        }
                        });

                    }if (response.data.status == 0) {
                        this.error = "Error Ocurred - Unable to delete office";
                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
        addUser() {
            let user_object = {
                'user_id': this.search_user,
                'office_id': this.office_details.id,
                'office_name': this.office_details.name
            }
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/offices/adduser`, user_object).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.add_user_dialog_box = false;
                        this.getOfficeDetails();
                        this.$router.push({
                        name: 'showOfficeDetails',
                        params: {
                            id: this.office_details.id
                        }
                    });

                    }
                    if (response.data.status == 0) {
                        this.error = "Error Ocurred";
                    }
                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
        deleteUser(user) {
            this.to_be_deleted_user = user;
            this.delete_user_dialog_box = true;
        },
        confirmDeleteUser() {
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/users/` + this.to_be_deleted_user.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.delete_user_dialog_box = false;
                        this.getOfficeDetails();

                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        }
    },
    data() {
        return {
           
            image: require('@/assets/images/building.png'),
            office_details: { wing:{}},
            loaders: {
                detail_loader: false,
            },
            error: '',
            success:'',
            user_search: '',
            delete_office_dialog_box: false,
            delete_user_dialog_box: false,
            add_user_dialog_box: false,
            office_related_users: [],
            office_related_visits: [],
            visit_headers: [{
                    text: 'Image',
                    align: 'left',
                    value: 'image',
                },
                {
                    text: 'Visitor',
                    value: 'visitor_id',
                    sortable: false,
                },
                {
                    text: 'Type',
                    value: 'type'
                },
                {
                    text: 'Time',
                    value: 'time'
                },
                {
                    text: 'Office',
                    value: 'office_id',
                    sortable: false
                },
                {
                    text: 'Action',
                    value: '',
                    sortable: false
                }
            ],
            user_headers: [{
                    text: 'User Name',
                    align: 'left',
                    value: 'username',
                    sortable: false,
                },
                {
                    text: 'Action',
                    value: '',
                    sortable: false
                    
                }
               
            ],
            search_user: "",
            is_loading: false,
            count:'',
            search_message: "Enter atleast 3 characters",
            users: [],
            total_items:10,
            options: {},
            message:'',
            alert: false,
            alert_error:false,
            role:'',
        }
    },
    mounted() {
       if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.role = localStorage.getItem('visitor_management_role');
        this.getOfficeDetails();
    }
};
</script>
